// eslint-disable-next-line no-shadow
export enum UserRole {
    Customer,
    Admin,
    Guest
}
